import React from "react";
import { Link } from "react-router-dom";

function ProjectCards({ project }) {
  const imageClassName = project.imageClassName
    ? `project-card-image ${project.imageClassName}`
    : "project-card-image";

  return (
    <article className="project-card">
      <Link
        to={`/projects/${project.id}`}
        className={imageClassName}
        aria-label={`View ${project.title}`}
      >
        <img
          src={project.coverImage}
          alt={`${project.title} evidence`}
          loading="lazy"
        />
      </Link>

      <div className="project-card-content">
        <div className="project-card-meta">
          <span>{project.category}</span>
          <span>{project.status}</span>
        </div>

        <h3>{project.title}</h3>

        <p>{project.summary}</p>

        <div className="project-card-technologies">
          {project.technologies.slice(0, 4).map((technology) => (
            <span key={technology}>{technology}</span>
          ))}
        </div>

        <Link
          to={`/projects/${project.id}`}
          className="project-card-link"
        >
          View project
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </article>
  );
}

export default ProjectCards;